import React from 'react'

type LogoProps = {
  /* @default 142 */
  width?: number
  /* @default 646 */
  height?: number
  /* @default light */
  theme?: 'light' | 'dark' | 'red'
}

export const Logo: React.FunctionComponent<LogoProps> = ({ theme = 'light', height = 50, width = 150 }) => {
  // const fontColor = theme === 'light' ? Colors.WHITE : Colors.BLACK
  let fontColor = '#ff0033'

  if (theme === 'light') {
    fontColor = '#ff0033'
  } else if (theme === 'dark') {
    fontColor = '#ff0033'
  } else if (theme === 'red') {
    fontColor = '#ff0033'
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      fill={fontColor}
      viewBox="0 0 270 58.5"
    >
      <path
        className="st0"
        d="M36.6,10.5L36.6,10.5c0.1,0.1,0.2,0.2,0.3,0.2c8-6.2,28.1-17,50.4,8.1c2.5-1,5.1-1.5,7.8-1.3
	C71.2-12.2,45.6,3.3,36.6,10.5z"
      />
      <polygon className="st0" points="36.9,10.7 36.8,10.7 36.8,10.7 " />
      <path
        className="st0"
        d="M177.3,40L177.3,40c-9.3,8.2-36.6,27.4-64.2,0.7h-9.4c30.5,35.3,64.1,9,74.1-0.4l0,0
	C177.5,40.2,177.4,40.1,177.3,40z"
      />
      <path
        className="st0"
        d="M181.1,33.9c-1.7,0-3.1,1.2-3.4,2.8c-0.1,1.4,0.8,2.6,2.2,2.7c0.1,0,0.3,0,0.4,0c1.7,0,3.2-1.2,3.5-2.8
	c0.1-1.4-0.9-2.6-2.2-2.8C181.4,33.9,181.2,33.9,181.1,33.9z"
      />
      <path
        className="st0"
        d="M33.9,11.2c-1.7,0-3.1,1.1-3.5,2.8c-0.1,1.2,0.7,2.4,2,2.5c0.2,0,0.3,0,0.5,0c1.7,0,3.2-1.1,3.5-2.8
	c0.1-1.2-0.7-2.3-2-2.5C34.2,11.2,34,11.2,33.9,11.2z"
      />
      <path className="st0" d="M22.5,40.5c-1.2,3.7-3.3,8.3-6,8.3v0.1c5.8,0,8.7-2.8,10.3-7.8l7.1-21.6h-4.5L22.5,40.5z" />
      <path
        className="st0"
        d="M7.7,22.8l1.1-3.3h4l0.4-1.4c1.7-5.3,5.1-8,10.9-8c1.2,0,2.4,0.1,3.5,0.4l-1.5,3.4c-0.9-0.2-1.9-0.3-2.8-0.4
	c-2.8,0-4.5,1.3-5.6,4.7l-0.4,1.3h5.5l-1.1,3.3h-5.4l-6,18.4C8.7,46.1,5.8,49,0,49v-0.1c2.7,0,4.7-4.7,6-8.3l5.9-17.7L7.7,22.8z"
      />
      <path
        className="st0"
        d="M51.1,19.1c-7,0-13.4,5.4-14.3,13.3c-0.5,4.4,1.7,7,7.4,7c7.4-0.2,13.6-5.8,14.4-13.2C59,22,57,19.1,51.1,19.1z
	 M53.6,26.7c-0.6,5.1-4.3,9.1-8.4,9.1c-2.9,0-3.9-1.5-3.6-4c0.5-4.5,3.9-9.1,8.3-9.1C52.9,22.7,54,24.1,53.6,26.7z"
      />
      <path
        className="st0"
        d="M69.4,26.1L69.4,26.1c1-2.1,2-4.4,2.7-6.7h-4.4c-0.9,2.9-2.1,6.6-3,9.3L61.3,39h4.6l1.4-4.3
	c2-6,6.8-12.5,10.3-11.6l1.4-4C75.1,18.5,72.3,21.6,69.4,26.1z"
      />
      <path
        className="st0"
        d="M99.7,10.3l-2.9,9c-0.9-0.1-1.8-0.2-2.7-0.1c-9.5,0-14.5,7-15.4,14.2c-0.5,4.2,1,6.1,4.2,6.1
	c4.9,0,8.6-4.7,10.6-7.6h0.1c-1.2,2.3-2.2,4.7-3.1,7.2H95c0.7-2.3,1.5-4.9,2.2-7l7.1-21.6H99.7z M95.2,24.2
	c-1.5,4.5-6.5,11.6-10.1,11.6c-1.2,0-1.9-1-1.6-3.2c0.5-4.5,3.6-10.2,9.4-10.2c0.9,0,1.9,0.1,2.8,0.4L95.2,24.2z"
      />
      <polygon className="st0" points="112.7,10.3 103.3,39 107.9,39 117.3,10.3 " />
      <polygon className="st0" points="116.3,39 120.9,39 127.3,19.5 122.7,19.5 " />
      <path
        className="st0"
        d="M127.3,11.3c-1.7,0-3.1,1.1-3.5,2.8c-0.1,1.2,0.8,2.4,2,2.5c0.2,0,0.3,0,0.5,0c1.7,0,3.1-1.2,3.5-2.8
	c0.1-1.2-0.8-2.3-2-2.5C127.6,11.3,127.5,11.3,127.3,11.3z"
      />
      <path
        className="st0"
        d="M147.7,19c-4.4,0-8,3.6-10.5,7.4h-0.1c1.2-2.3,2.2-4.6,3-7h-4.5c-0.8,2.6-1.9,6.1-3,9.3L129.3,39h4.6l1.5-4.6
	c1.5-4.7,6.6-11.7,10.1-11.7c1.7,0,2.1,1.2,1.2,4l-4.1,12.4h4.6l4.4-13.4C152.8,21.7,151.8,19,147.7,19z"
      />
      <path
        className="st0"
        d="M170,19.1c-7,0-12.7,6-13.6,13.9c-0.5,4.4,1.5,6.5,6.7,6.5c2.7,0,5.3-0.4,7.9-1.2l0.4-3.3
	c-2,0.7-4.2,1.1-6.3,1.1c-3.3,0-4.3-0.7-4-3.4c0.1-0.7,0.2-1.3,0.4-2c9-0.3,14.1-2.6,14.7-7C176.4,21.4,175,19.1,170,19.1z
	 M171.5,24.2c-0.3,2.2-3.2,3.4-9.1,3.5c1.2-3,3.6-5.5,6.7-5.5C170.8,22.2,171.7,22.9,171.5,24.2z"
      />
      <path
        className="st0"
        d="M223.8,19.1c-3,0-6,1-8.4,2.8c-3.4,2.5-5.5,6.4-5.9,10.6c-0.5,4.4,1.7,7,7.4,7c7.4-0.2,13.6-5.9,14.4-13.3
	C231.8,22,229.7,19.1,223.8,19.1z M226.4,26.7c-0.6,5.1-4.3,9.1-8.4,9.1c-2.9,0-3.9-1.5-3.6-4c0.5-4.5,3.9-9.1,8.3-9.1
	C225.6,22.7,226.7,24.1,226.4,26.7z"
      />
      <path
        className="st0"
        d="M265.5,19.1c-4.6,0-8.4,3.6-11,7.5h-0.1c0.6-1.1,1.1-2.4,1.3-3.7c0.3-2.5-1.3-3.9-4.2-3.9
	c-4.6,0-8.4,3.6-11,7.4h-0.1c1.2-2.3,2.3-4.6,3.1-7h-4.8c-0.4,1.3-2.5,8-3,9.4L232.3,39h4.9l1.5-4.6c1.9-5.7,7.2-11.7,10.5-11.7
	c1.7,0,2.2,1.2,1.2,4l-4.1,12.4h4.8l1.5-4.6c1.9-5.7,7.2-11.7,10.5-11.7c1.7,0,2.2,1.2,1.2,4l-4.2,12.4h4.9l4.5-13.4
	C270.9,21.8,269.7,19.1,265.5,19.1z"
      />
      <path
        className="st0"
        d="M189.5,32.6c-0.4,3.9,1.5,6.6,7.6,6.6c2.1,0,4.1-0.3,6.1-0.9l0.5-3.4c-1.5,0.5-3.1,0.8-4.7,0.8h0
	c-1.3,0.1-2.5-0.3-3.5-1.1c-0.6-0.8-0.9-1.9-0.7-2.9c0.5-4.5,3.8-9.3,9-9.3l0,0c1.3,0,2.7,0.2,3.9,0.7l1.5-3.5
	c-1.6-0.4-3.1-0.6-4.7-0.6C196.1,19,190.3,25.1,189.5,32.6z"
      />
    </svg>
  )
}

export default Logo
